<!--
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-01 00:42:30
 * @LastEditors: myname
 * @LastEditTime: 2022-04-04 03:49:55
-->
<template>
  <div
    class="common-switch"
    @click="btnClick"
  >
    <span class="active_text">
      <i :style="{background: activeColor}"></i>
      {{activeText}}
    </span>
    <div class="line" :class="{active: isActive}">
      <span class="point"></span>
    </div>
    <span class="inactive_text">
      <i :style="{background: inactiveColor}"></i>
      {{inactiveText}}
    </span>
  </div>
</template>

<script>
export default {
  name: "commonSwitch",
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("click");
    },
  },
  props: {
    isActive: {
      default: true,
      type: Boolean
    },
    activeText: {
      type: String,
      default: 'red'
    },
    inactiveText: String,
    activeColor: String,
    inactiveColor: {
      type: String,
      default: 'red'
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-switch{
  display: flex;
  align-items: center;
}
.common-switch .active_text,
.common-switch .inactive_text{
  display: flex;
  align-items: center;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  color: black;
  border:1px solid black;
  font-size: 16px;
  padding: 0 14px;
}

.common-switch .active_text i,
.common-switch .inactive_text i{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100px;
  margin-right: 10px;
}
.common-switch .line{
  position: relative;
  width: 80px;
  height: 20px;
  margin: 0 10px;
  border-radius: 30px;
  background: #FF7F7F;
  transition: 0.3s;
  cursor: pointer;
}
.common-switch .line.active{
  background: #68BA2F;
}

.common-switch .line .point{
  position: absolute;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  border-radius: 100px;
  z-index: 9;
  top: -4px;
  right: 0;
  background: #FF7F7F;
}
.common-switch .line.active .point{
  right: calc(100% - 30px);
}
.common-switch .line .point::after{
  display: block;
  content: '';
  position: absolute;
  left: 1.9968px;
  width: calc(100% - 0.0208rem);
  height: calc(100% - 0.0208rem);
  top: 0.0104rem;
  background: #fff;
  border-radius: 100px;
}
.common-switch .line .point::before{
  display: block;
  content: '';
  position: absolute;
  left: 0.026rem;
  width: calc(100% - 0.0521rem);
  height: calc(100% - 0.0521rem);
  top: 0.026rem;
  background: #FF7F7F;
  border-radius: 100px;
  z-index: 9;
}
.common-switch .line.active .point,
.common-switch .line.active .point::before{

  background: #68BA2F;
}
</style>
